
import App from '../App';
import { getWebUrl } from '../common/util';

const Index = [
  {
    path: '/',
    Component: App,
    children: [
    ],
  },
];

export default Index;
